import { render, staticRenderFns } from "./pos-clientList.vue?vue&type=template&id=8167b58a"
import script from "./pos-clientList.vue?vue&type=script&lang=js"
export * from "./pos-clientList.vue?vue&type=script&lang=js"
import style0 from "./pos-clientList.vue?vue&type=style&index=0&id=8167b58a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports